export * from "./ContentSmall";
